const alertBar = {
  alertBarContent: null,
  alertBar: null,
  closeButton: null,

  init() {
    this.alertBar = document.querySelector('.alertbar');
    this.alertBarContent = this.alertBar.querySelector('.alertbar__content');
    this.closeButton = this.alertBar.querySelector('.alertbar__close');

    if (!this.alertBar) {
      console.error('alertBarContent element not found!');
      return;
    }
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }
  },

  close() {
    console.log('closing')
    this.alertBarContent.textContent = '';
    this.alertBar.classList.add('closed');

  },

  open(message, bg, color = 'white', dur = 5000) {
    console.log('opening')
    this.alertBarContent.innerHTML = message;
    this.alertBar.style.setProperty('--bg', bg);
    this.alertBar.style.setProperty('--color', color);
    this.alertBar.classList.remove('closed');
    setTimeout(() => this.close(), dur);
    
  },
};

// Initialize after DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  alertBar.init();
});